/**
 * Maps trait names (specialities starting with "_") to icon filenames
 * Trait names come from unit specialities and need to be mapped to icon files
 * in the /images/specialities/ directory
 */

const traitIconMap: Record<string, string> = {
  // Direct mappings (trait name without "_" matches icon name)
  "_airlift": "airlift.png",
  "_amphibie": "amphibie.png",
  "_canBeAirlifted": "canBeAirlifted.png",
  "_electronic_warfare": "electronic_warfare.png",
  "_eo_dazzler": "eo_dazzler.png",
  "_era": "era.png",
  "_falseflag": "falseflag.png",
  "_fireDirection": "fireDirection.png",
  "_gsr": "gsr.png",
  "_instructor": "instructor.png",
  "_jammer": "jammer.png",
  "_cbr": "artillery_radar.png",
  "_militia": "militia.png",
  "_mountaineer": "mountaineer.png",
  "_mp": "mp.png",
  "_para": "para.png",
  "_resolute": "resolute.png",
  "_security": "security.png",
  "_sf": "sf.png",
  "_singint": "singint.png",
  "_smoke_launcher": "smoke_launcher.png",
  "_sniper": "sniper.png",
  "_transport1": "transport1.png",
  "_transport2": "transport2.png",
  
  // Special cases (trait name doesn't match icon name directly)
  "_choc": "shock.png",
  "_ifv": "ifv_2.png",
  "_leader": "cmd.png",
  "_reco": "reco_deploy.png",
  "_reservist": "reserviste.png",
};

/**
 * Get the icon path for a trait name
 * @param traitName - The trait name (e.g., "_airlift", "_choc")
 * @returns The path to the icon image, or null if no mapping exists
 */
export function getTraitIconPath(traitName: string): string | null {
  const iconFilename = traitIconMap[traitName];
  if (!iconFilename) {
    return null;
  }
  return `/images/specialities/${iconFilename}`;
}

/**
 * Filter specialities to only include traits (those starting with "_")
 * @param specialities - Array of speciality names
 * @returns Array of trait names (filtered)
 */
export function filterTraits(specialities: string[]): string[] {
  return specialities.filter(spec => spec.startsWith("_"));
}

